module.exports = __webpack_public_path__ + "img/Harmless.daccb06c.png";